// Allowed document open preferences: Desktop,Inline, Web.
export var ContentOpenPreference;
(function (ContentOpenPreference) {
    ContentOpenPreference["Desktop"] = "Desktop";
    ContentOpenPreference["Inline"] = "Inline";
    ContentOpenPreference["Web"] = "Web";
    ContentOpenPreference["Unknown"] = "Unknown";
})(ContentOpenPreference || (ContentOpenPreference = {}));
//# sourceMappingURL=ContentOpenPreference.js.map